import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Grid,
    Table,
    TableContainer,
    Paper,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Slide,
    Typography,
    Fab
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[400],
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

class AssetLocationHistoryDialog extends Component {

    closeDialog = () => {
        this.props.onClose();
    }

    render() {
        const { locationsHistory } = this.props

        let locationsHistoryList;
        let recordsNotFound;
        if (locationsHistory && locationsHistory.length > 0) {
            locationsHistoryList = locationsHistory.map((locationHistory, index) => {
                return <TableRow key={index}>
                    <TableCell>{locationHistory.startDate}</TableCell>
                    <TableCell>{locationHistory.location.address}</TableCell>
                    <TableCell>{locationHistory.location.floor}</TableCell>
                    <TableCell>{locationHistory.location.room}</TableCell>
                    <TableCell>{locationHistory.location.city}</TableCell>
                </TableRow >
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return (
            <Dialog onClose={() => this.props.onClose()} open={this.props.isOpen} TransitionComponent={Transition} fullWidth>
                <DialogTitle className="dialog-header-custom" onClose={this.props.onClose}>{this.props.t("location_history")}{" "}{this.props.assetName}</DialogTitle>
                <DialogContent>
                    <Grid container direction="row" spacing={2}>
                        <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table" size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell component="th" scope="row" width="25%">{this.props.t("start_date")}</TableCell>
                                                    <TableCell component="th" scope="row" width="30%">{this.props.t("address")}</TableCell>
                                                    <TableCell component="th" scope="row" width="15%">{this.props.t("floor")}</TableCell>
                                                    <TableCell component="th" scope="row" width="15%">{this.props.t("room")}</TableCell>
                                                    <TableCell component="th" scope="row" width="15%">{this.props.t("city")}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {locationsHistoryList}
                                                {recordsNotFound}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={"dialog-actions-fix"}>
                    <Fab
                        style={{ marginRight: 10 }}
                        size="small"
                        color="primary"
                        component={Link}
                        to={{
                            pathname: `/history/` + this.props.assetId,
                            state: {
                                selectedClient: this.props.selectedClient,
                                selectedReportingYear : this.props.selectedReportingYear,
                                selectedInventory : this.props.selectedInventory,
                                inventoryNumber : this.props.inventoryNumber,
                                assetName : this.props.assetName,
                                selectedFrom: this.props.selectedFrom,
                                selectedTo: this.props.selectedTo,
                                inactiveAssets: this.props.inactiveAssets
                            }
                        }}>
                        <EditIcon />
                    </Fab>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withRouter(withTranslation()(AssetLocationHistoryDialog));